import { useMemo } from 'react';

import { JobApplicationFormExternalDoc, JobApplicationFormExternalDocType } from '../../../../graphql/generated';

type ExternalDocumentsUrls = string[] | undefined;

type UrlsOfExternalDocumentsType = Record<JobApplicationFormExternalDocType, ExternalDocumentsUrls> & {
  OTHER: ExternalDocumentsUrls;
};

export const useExternalDocuments = (
  externalDocuments: JobApplicationFormExternalDoc[]
): UrlsOfExternalDocumentsType => {
  return <UrlsOfExternalDocumentsType>useMemo(() => {
    return externalDocuments.reduce((externalDocumentsUrls, obj) => {
      const type =
        obj.type === JobApplicationFormExternalDocType.PrivacyPolicy ||
        obj.type === JobApplicationFormExternalDocType.TermsAndConditions
          ? obj.type
          : 'OTHER';

      if (!externalDocumentsUrls[type]) externalDocumentsUrls[type] = [];
      externalDocumentsUrls[type].push(obj.url);

      return externalDocumentsUrls;
    }, {});
  }, [externalDocuments]);
};
